import src from "IMAGE";
export default { src, width: 307, height: 337, blurWidth: 7, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAARElEQVR42p2KSQ4AIAjE/P9vjRp3RwTjdnRIL7QKcw0FFQEZFgmaUVtWukiJo8Awl2z0ksAzSw4tQeFocEgJTh557192og7ea8R2KBsAAAAASUVORK5CYII="};
